import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const LogoutArrowIcon = createIcon({
  displayName: 'LogoutArrow',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <line x1="3" x2="14" y1="12" y2="12" />
        <polyline points="11,9 14,12 11,15" />
        <path d="M6 9.137v-1.737l-7.00458e-09 1.16545e-05c.000569992-.952997.673477-1.77322 1.60799-1.96001l11-2.406 -1.77227e-08 2.04745e-09c1.17737-.136019 2.24209.708165 2.3781 1.88554 .0107536.0930829.0153992.18677.0139069.28046v13.8l-1.76767e-08-3.6899e-05c.000539341 1.10457-.894454 2.00044-1.99902 2.00098 -.113931 5.56302e-05-.227658-.00962397-.33994-.0289332l-11-1.892 -3.11515e-09-5.3571e-10c-.960044-.165098-1.66149-.99787-1.66104-1.97201v-2.137" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0 0h24v24h-24Z" />
    </>
  ),
})

const LogoutArrow: FC<IconProps> = (props) => {
  return <CustomIcon as={LogoutArrowIcon} {...props} />
}

export default memo(LogoutArrow)
